import SvgIconDowload from '../@svg/SvgDowload';
import './index.scss';
import { Button, ButtonProps } from 'antd';

import { SvgArrowDownSelect } from '../@svg/SvgArrowDownSelect';

const DownloadButtonWithArrow = (props: ButtonProps) => {
  return (
    <Button className={`download-button download-button-arrow ${props.className}`} {...props}>
      <div className="download-button-arrow__left">
        <SvgIconDowload />
        <span>エクスポート</span>
      </div>
      <div className="download-button-arrow__separator"></div>
      <div className="download-button-arrow__right">
        <SvgArrowDownSelect />
      </div>
    </Button>
  );
};

export default DownloadButtonWithArrow;
